export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: "a1",
    slug: "aiye-2025-product-vision",
    title: "aiye 2025 年度产品展望：以智能化驱动行业变革",
    excerpt: "回顾过去一年的技术突破，展望 aiye 在新一年中的产品路线图与战略方向，看我们如何持续引领行业创新。",
    content: `<p>2025 年，aiye 将继续深耕智能化解决方案领域，以技术创新为核心驱动力，为用户带来更加卓越的产品体验。</p>
    <h3>回顾 2024：夯实基础，稳步前行</h3>
    <p>过去一年，aiye 在智能决策、数据分析、云服务等多个领域取得了显著进展。我们完成了核心产品矩阵的全面升级，推出了多项行业领先的技术方案，服务了超过 2000 家企业客户。</p>
    <p>在产品稳定性方面，我们实现了 99.99% 的系统可用性 SLA，获得了客户的一致好评。在技术创新方面，我们申请了 47 项技术专利，其中 28 项已获授权。</p>
    <h3>展望 2025：五大核心方向</h3>
    <p><strong>1. 深度智能化升级</strong>：我们将全面引入最新的大语言模型技术，让 aiye 的产品具备更强的自然语言理解和推理能力，实现真正的「对话式」人机交互。</p>
    <p><strong>2. 全链路数据打通</strong>：构建统一的数据中台，打通从数据采集、清洗、分析到应用的全链路，让数据真正流动起来，释放更大的商业价值。</p>
    <p><strong>3. 行业场景深耕</strong>：针对金融、医疗、制造、零售等垂直行业，推出定制化的解决方案，让 aiye 的产品更加贴近实际业务场景。</p>
    <p><strong>4. 开放生态建设</strong>：开放更多 API 和 SDK，打造繁荣的开发者生态。我们相信，只有开放的生态才能激发无限的创新可能。</p>
    <p><strong>5. 全球化布局加速</strong>：在巩固国内市场的同时，积极拓展海外业务，让 aiye 的产品和服务走向世界舞台。</p>
    <h3>与用户同行</h3>
    <p>产品的发展离不开用户的支持与反馈。2025 年，我们将建立更加紧密的用户社区，定期举办线上线下的交流活动，倾听每一位用户的声音。</p>
    <p>aiye 的每一步成长，都有您的见证与参与。让我们携手共进，以智能化的力量，驱动行业的每一次变革。</p>`,
    category: "品牌动态",
    categorySlug: "brand-news",
    author: "aiye 产品团队",
    date: "2025-01-15",
    readTime: "8 分钟",
    image: "https://readdy.ai/api/search-image?query=Modern%20corporate%20vision%20concept%20with%20abstract%20geometric%20shapes%20in%20warm%20terracotta%20and%20cream%20tones%20clean%20minimalist%20professional%20blog%20featured%20image&width=800&height=450&seq=article-1&orientation=landscape",
    tags: ["产品展望", "智能化", "行业趋势", "aiye"],
  },
  {
    id: "a2",
    slug: "aiye-security-best-practices",
    title: "企业安全防护指南：aiye 为您构建坚不可摧的数字防线",
    excerpt: "深入解析当前企业面临的主要安全威胁，并介绍 aiye 安全防护体系如何帮助您构建全方位的数字安全防线。",
    content: `<p>在数字化转型的浪潮中，网络安全已成为企业生存和发展的生命线。今天，我们将深入探讨企业面临的安全挑战以及 aiye 的安全防护解决方案。</p>
    <h3>当前企业面临的安全威胁</h3>
    <p>随着攻击手段的不断演进，企业面临的网络安全威胁日益复杂。勒索软件、APT 攻击、数据泄露等已经成为高频事件。据统计，2024 年全球数据泄露的平均成本已超过 450 万美元。</p>
    <p>传统的边界防护理念已经无法应对现代化的网络攻击。企业需要的是一套完整的、多层次的纵深防御体系。</p>
    <h3>aiye 安全防护四层架构</h3>
    <p><strong>第一层：边界防护</strong> — 采用 aiye 下一代防火墙与入侵检测系统，实时监测并拦截来自外部的恶意流量，构建第一道数字防线。</p>
    <p><strong>第二层：身份认证</strong> — 基于零信任架构，对接入用户和设备进行持续的身份验证和权限管理，确保「最小权限」原则。</p>
    <p><strong>第三层：数据安全</strong> — 端到端的数据加密与脱敏方案，保障敏感数据在存储、传输和使用过程中的绝对安全。</p>
    <p><strong>第四层：态势感知</strong> — aiye 安全态势感知平台，利用 AI 技术实时分析全网安全事件，提前预警潜在威胁，实现主动防御。</p>
    <h3>实施建议</h3>
    <p>安全建设不是一蹴而就的工程。我们建议企业采用「小步快跑」的策略，先从最核心的资产保护入手，逐步完善安全体系。aiye 的专业安全团队将全程为您提供咨询与支持。</p>`,
    category: "技术指南",
    categorySlug: "tech-guides",
    author: "aiye 安全团队",
    date: "2025-02-20",
    readTime: "10 分钟",
    image: "https://readdy.ai/api/search-image?query=Cybersecurity%20shield%20concept%20abstract%20digital%20defense%20visualization%20modern%20clean%20design%20warm%20terracotta%20and%20cream%20tones%20professional%20blog%20image&width=800&height=450&seq=article-2&orientation=landscape",
    tags: ["安全防护", "企业安全", "技术指南", "aiye"],
  },
  {
    id: "a3",
    slug: "aiye-data-driven-decision",
    title: "数据驱动决策：aiye 数据分析平台实战应用",
    excerpt: "通过真实案例，展示 aiye 数据分析平台如何帮助企业从海量数据中提取洞见，实现数据驱动的科学决策。",
    content: `<p>在信息爆炸的时代，数据已成为企业最宝贵的资产之一。但数据本身不会说话，关键在于如何从中提取有价值的洞察。本文将分享 aiye 数据分析平台的实战应用经验。</p>
    <h3>从数据到洞察的四个步骤</h3>
    <p><strong>第一步：数据接入</strong> — aiye 平台支持接入超过 200 种数据源，包括数据库、API、文件等多种格式，实现数据的统一汇聚。</p>
    <p><strong>第二步：数据清洗</strong> — 内置智能数据清洗引擎，自动识别并处理重复值、缺失值、异常值，确保分析基础的数据质量。</p>
    <p><strong>第三步：分析建模</strong> — 提供拖拽式的分析工作流，零代码即可完成复杂的数据分析任务。同时支持 Python 和 SQL 高级分析。</p>
    <p><strong>第四步：可视化呈现</strong> — 丰富的可视化组件库，一键生成专业的分析报告和仪表盘，让数据故事更加生动有力。</p>
    <h3>实战案例：零售行业销量预测</h3>
    <p>某连锁零售企业使用 aiye 平台构建了销量预测模型。通过接入历史销售数据、天气数据、促销活动数据等多维度信息，模型预测准确率达到了 92%，帮助企业优化了库存管理，季度库存成本降低了 18%。</p>
    <h3>开始你的数据之旅</h3>
    <p>无论你是数据分析新手还是资深专家，aiye 平台都能为你提供得心应手的分析工具。现在就注册 aiye，开启你的数据驱动之旅吧。</p>`,
    category: "产品应用",
    categorySlug: "product-apps",
    author: "aiye 数据团队",
    date: "2025-03-08",
    readTime: "7 分钟",
    image: "https://readdy.ai/api/search-image?query=Data%20analytics%20and%20business%20intelligence%20concept%20abstract%20visualization%20modern%20clean%20design%20warm%20terracotta%20and%20cream%20tones%20professional%20blog%20image&width=800&height=450&seq=article-3&orientation=landscape",
    tags: ["数据分析", "数据驱动", "实战案例", "aiye"],
  },
  {
    id: "a4",
    slug: "aiye-cloud-migration-guide",
    title: "企业上云全攻略：aiye 助您平稳迁移无忧",
    excerpt: "一份完整的企业云迁移指南，涵盖规划、实施、优化全流程，解析 aiye 云服务如何保障迁移过程的安全与高效。",
    content: `<p>云迁移是数字化转型的重要里程碑，但也是一个充满挑战的过程。aiye 云服务团队基于数百个成功案例的经验，为您整理了这份完整的上云指南。</p>
    <h3>上云前的三大准备</h3>
    <p><strong>1. 全面评估</strong>：梳理现有 IT 资产清单，评估各系统对云环境的兼容性，制定详细的迁移优先级排序。</p>
    <p><strong>2. 安全规划</strong>：确定云环境的安全架构，包括网络隔离、访问控制、数据加密等关键安全策略。</p>
    <p><strong>3. 成本预算</strong>：利用 aiye 的成本计算器，预估云资源的使用量和费用，制定合理的预算方案。</p>
    <h3>aiye 的平滑迁移方案</h3>
    <p>我们提供「三步走」的迁移策略：先迁移非核心业务进行验证，积累经验后再迁移核心系统，最后进行整体的优化调整。整个过程由 aiye 专业技术团队全程护航。</p>
    <h3>迁移后的持续优化</h3>
    <p>上云不是终点，而是新的起点。aiye 提供智能化的云资源优化建议，自动识别闲置资源，帮助您持续降低云成本，提升资源利用效率。</p>`,
    category: "技术指南",
    categorySlug: "tech-guides",
    author: "aiye 云服务团队",
    date: "2025-03-25",
    readTime: "9 分钟",
    image: "https://readdy.ai/api/search-image?query=Cloud%20migration%20concept%20with%20abstract%20server%2C%20data%20transfer%20visualization%20modern%20clean%20design%20warm%20terracotta%20and%20cream%20tones%20professional%20blog%20image&width=800&height=450&seq=article-4&orientation=landscape",
    tags: ["云迁移", "云服务", "技术指南", "aiye"],
  },
  {
    id: "a5",
    slug: "aiye-iot-smart-manufacturing",
    title: "物联网赋能智能制造：aiye IoT 平台实践分享",
    excerpt: "探讨物联网技术在制造业的应用场景，分享 aiye IoT 平台在智慧工厂建设中的成功实践经验。",
    content: `<p>工业 4.0 时代，物联网正在深刻改变制造业的运作方式。aiye IoT 平台为制造企业提供了从设备连接到智能决策的完整技术栈。</p>
    <h3>智慧工厂的核心要素</h3>
    <p>一个真正的智慧工厂，需要实现设备互联、数据互通、智能决策三个层次的数字化。aiye IoT 平台正是围绕这三个层次构建的。</p>
    <p><strong>设备互联</strong>：支持 Modbus、OPC UA、MQTT 等主流工业协议，快速接入各类生产设备、传感器和控制系统。</p>
    <p><strong>数据互通</strong>：统一的数据模型和 API 接口，打破信息孤岛，实现生产、质量、设备、能源等数据的全面融合。</p>
    <p><strong>智能决策</strong>：结合边缘计算和云端 AI，实现设备预测性维护、质量智能检测、生产动态排程等高级应用。</p>
    <h3>案例：某汽车零部件工厂</h3>
    <p>通过部署 aiye IoT 平台，该工厂实现了 300+ 台设备的实时监控，设备综合效率（OEE）提升了 15%，非计划停机时间减少了 40%，年节省成本超过 800 万元。</p>`,
    category: "产品应用",
    categorySlug: "product-apps",
    author: "aiye IoT 团队",
    date: "2025-04-12",
    readTime: "8 分钟",
    image: "https://readdy.ai/api/search-image?query=Smart%20manufacturing%20IoT%20factory%20concept%20abstract%20visualization%20modern%20clean%20design%20warm%20terracotta%20and%20cream%20tones%20professional%20blog%20image&width=800&height=450&seq=article-5&orientation=landscape",
    tags: ["物联网", "智能制造", "IoT平台", "aiye"],
  },
  {
    id: "a6",
    slug: "aiye-team-collaboration-efficiency",
    title: "远程办公效率翻倍：aiye 团队协作工具深度评测",
    excerpt: "远程办公已成为新常态，aiye 团队协作工具如何帮助分布式团队保持高效协作？本文为您全面解析。",
    content: `<p>后疫情时代，混合办公模式已成为主流。如何让分布在不同地点的团队成员高效协作，是每个管理者都需要面对的挑战。aiye 团队协作空间正是为解决这一问题而生。</p>
    <h3>一体化协作体验</h3>
    <p>aiye 团队协作空间将即时通讯、文档协作、项目管理、视频会议四大核心功能整合在一个平台中，告别在多个工具间来回切换的痛苦。</p>
    <p><strong>即时通讯</strong>：支持频道分组、话题讨论、消息引用，让团队沟通更加有序高效。</p>
    <p><strong>文档协作</strong>：多人实时协同编辑，支持 Markdown 和富文本，版本历史自动保存。</p>
    <p><strong>项目管理</strong>：看板、列表、甘特图多种视图，灵活的自动化规则，让项目推进一目了然。</p>
    <p><strong>视频会议</strong>：高清稳定的音视频通话，支持屏幕共享、虚拟白板和会议纪要自动生成。</p>
    <h3>真实用户反馈</h3>
    <p>「自从团队切换到了 aiye 协作空间，我们的会议时间减少了 30%，但项目进度反而更快了。」— 来自某互联网公司的产品经理。</p>`,
    category: "产品应用",
    categorySlug: "product-apps",
    author: "aiye 产品团队",
    date: "2025-05-06",
    readTime: "6 分钟",
    image: "https://readdy.ai/api/search-image?query=Remote%20team%20collaboration%20concept%20abstract%20digital%20workspace%20visualization%20modern%20clean%20design%20warm%20terracotta%20and%20cream%20tones%20professional%20blog%20image&width=800&height=450&seq=article-6&orientation=landscape",
    tags: ["团队协作", "远程办公", "产品评测", "aiye"],
  },
];

export const articlesByCategory: Record<string, Article[]> = {
  "brand-news": [articles[0]],
  "tech-guides": [articles[1], articles[3]],
  "product-apps": [articles[2], articles[4], articles[5]],
};

export const articleCategories = [
  { name: "全部文章", slug: "all", count: articles.length },
  { name: "品牌动态", slug: "brand-news", count: 1 },
  { name: "技术指南", slug: "tech-guides", count: 2 },
  { name: "产品应用", slug: "product-apps", count: 3 },
];